
import React from 'react';
import styles from './GoalModal.module.css';
import Button from './Button';

interface GoalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectGoal: (goal: string) => void;
}

const GoalModal: React.FC<GoalModalProps> = ({ isOpen, onClose, onSelectGoal }) => {
  if (!isOpen) {
    return null;
  }

  const goals = [
    'Save for a big purchase',
    'Track Spending',
    'Reduce Expenses',
  ];

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>What is your goal?</h2>
        <div className={styles.goalsContainer}>
          {goals.map((goal) => (
            <Button key={goal} onClick={() => onSelectGoal(goal)} className={styles.goalButton}>
              {goal}
            </Button>
          ))}
        </div>
        <Button onClick={onClose} className={styles.closeButton}>Close</Button>
      </div>
    </div>
  );
};

export default GoalModal;
